import { getUrlParams } from "../components/router/Router";

export function getComputopUrlParams() {
    const urlParams = getUrlParams();

    return {
        data: urlParams.get("data"),
    };
}
